import ApiService from '../apiservice'

export default class ProvisaoJudicialService extends ApiService {
  constructor() {
    super('/provisao-judicial')
  }

  consultarTipos(empresa) {
    return this.get(`/tipos/${empresa}`);
  }

  provisoesPorProcesso(processo) {
    return this.get(`/provisoes-por-processo/${processo}`);
  }

  cadastrarProvisao(provisao) {
    return this.post('/',provisao);
  }

  consultarProvisao(codigo) {
    return this.get(`/consultar-por-codigo/${codigo}`);
  }

  alterarProvisao(provisao) {
    return this.put('/',provisao);
  }

  excluirProvisao(codigo) {
    return this.delete(`/${codigo}`);
  }
}